import {
	PATIENT_ACCOUNT_DATA_ACTION_TYPES,
	PatientAccountDataActions,
	PatientAccountDataState,
} from '../../../../types/patientAccountData'

const initialState: PatientAccountDataState = {
	records: [],
}

export default (
	state = initialState,
	action: PatientAccountDataActions
): PatientAccountDataState => {
	switch (action.type) {
		case PATIENT_ACCOUNT_DATA_ACTION_TYPES.PATIENT_ACCOUNT_DATA: {
			return {
				records: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
